module.exports = __webpack_public_path__ + "img/mask.120448c0.png";